var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 12.9165H5C4.31667 12.9165 3.75 12.3498 3.75 11.6665C3.75 10.9832 4.31667 10.4165 5 10.4165H35C35.6833 10.4165 36.25 10.9832 36.25 11.6665C36.25 12.3498 35.6833 12.9165 35 12.9165Z",
    fill: "#26B5ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 21.2498H5C4.31667 21.2498 3.75 20.6832 3.75 19.9998C3.75 19.3165 4.31667 18.7498 5 18.7498H35C35.6833 18.7498 36.25 19.3165 36.25 19.9998C36.25 20.6832 35.6833 21.2498 35 21.2498Z",
    fill: "#26B5ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 29.5832H5C4.31667 29.5832 3.75 29.0165 3.75 28.3332C3.75 27.6498 4.31667 27.0832 5 27.0832H35C35.6833 27.0832 36.25 27.6498 36.25 28.3332C36.25 29.0165 35.6833 29.5832 35 29.5832Z",
    fill: "#26B5ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrgMenu);
export default __webpack_public_path__ + "static/media/brg-menu.bb823495015818f7a292acaaf3c9de4e.svg";
export { ForwardRef as ReactComponent };